export default function MapPinIcon(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M33.6,55.206l-2.89323e-08,4.0241e-08c-0.631356,0.878133 -1.85504,1.07819 -2.73317,0.446829c-0.17215,-0.123772 -0.323058,-0.274679 -0.446829,-0.446829c-2.776,-3.8894 -14.41,-20.8054 -14.41,-31.1853l1.88294e-13,2.41593e-06c-1.33428e-06,-8.83656 7.16344,-16 16,-16c8.83656,-1.33428e-06 16,7.16344 16,16c0,0 0,1.42109e-14 0,1.42109e-14c1.77636e-13,10.3799 -11.6334,27.2959 -14.41,31.1853Zm-1.59,-41.1851l-4.37114e-07,1.06581e-14c-5.52285,2.41411e-07 -10,4.47715 -10,10c2.41411e-07,5.52285 4.47715,10 10,10c5.52285,-2.41411e-07 10,-4.47715 10,-10c0,0 0,-3.55271e-15 0,-3.55271e-15l7.10543e-15,4.37114e-07c0,-5.52285 -4.47715,-10 -10,-10Z"></path>
    </svg>
  )
}
